export default __webpack_public_path__ + "5c8b477f2d00ba1eb9eb1d75572b7857.jpg";